var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewfinderProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "40px",
    viewBox: "0 0 37 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3FC34E77-7FD2-4821-AED5-C87D2C48DAE2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investment-viewfinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-investment-attributes",
    transform: "translate(-590.000000, -259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(135.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attributes",
    transform: "translate(145.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "protection",
    transform: "translate(224.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/viewfinder/protection",
    transform: "translate(60.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/protection",
    transform: "translate(1.666667, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6447852,0.754547192 C9.4174776,3.30637048 3.84810097,5.01330052 1.95369621,5.86976021 C1.58721686,5.99882071 1.35405337,6.31438286 1.35405337,6.66966838 C1.35405337,14.7869411 2.51914569,20.8150495 5.10643361,25.7381005 C7.71182766,30.7278279 11.8309781,34.7527414 18.136603,38.5268224 C18.4501651,38.7132842 18.8779498,38.7132842 19.1897531,38.5278856 C25.4968846,34.7529063 29.6159368,30.7280241 32.2226035,25.7363845 C34.795148,20.8413926 35.9393944,14.8370659 35.9393944,6.66966838 C35.9393944,6.31586043 35.7065516,5.99374349 35.3171819,5.84752961 C33.4551399,5.01360868 27.873916,3.30685564 18.6447852,0.754547192 Z",
    id: "Protection-Icon",
    stroke: "#3386BE",
    strokeWidth: 1.45454545,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6539718,4.54545458 C27.5285322,6.91232362 31.9658124,8.26083111 31.9658124,8.59097704 C31.9658124,14.4362205 31.1529049,19.3849406 29.1214563,23.1560202 C27.0900077,26.9512212 23.7799223,30.0060529 19.3412141,33.1258958 C18.9548946,33.3974289 18.3756728,33.407487 17.9955875,33.1258958 C13.0472981,29.4598902 10.1795896,26.4145754 8.14835248,22.6193744 C6.11690387,18.8482948 5.32763521,14.4362205 5.32763521,8.59097704 C5.32763521,8.26083111 9.76974742,6.91232362 18.6539718,4.54545458 Z",
    id: "Shape",
    fill: "#3386BE"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewfinderProtection);
export default __webpack_public_path__ + "static/media/viewfinder_protection.acd90e47a139b9780e1aa01d5874926d.svg";
export { ForwardRef as ReactComponent };